import { resolveProvider } from '@/shared/payments/paymentClientFactory'

export default function getVendorPaymentData(vendor) {
  return vendor?.[resolveProvider(vendor)]
}
